import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const DailyWorkChecklistProgressDashboardAPI = createAsyncThunk("ChecklistProgress", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_ZoneID,
        M_WardID,
        M_AssetTypeID,
        M_WorkTypeID,
        token,
        M_UsersID,
        Flag,
        Language,
        handleGetCount,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    url = `${BaseUrl}/APKDashboard/Get_WEB_GD_T_KPIUploadDailyWork_ChecklistProgress_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&M_AssetTypeID=${M_AssetTypeID}&M_WorkTypeID=${M_WorkTypeID}&M_UsersID=${M_UsersID}&Date=&Language=English&Flag=${Flag}&From=1&To=99999`

    return fetch(url, requestOptions)

        .then((res) => res.json())

        .then((result) => {
            if (result.code >= 200 && result.code <= 300 ) {              
                return result
            } else {
                return
            }
        })
        .catch((err) => {
            console.log("Error:", err)
            return err
        })
})

const DailyWorkChecklistProgressDashboardSlice = createSlice({
    name: "DistribuionCount",
    initialState: {
        isLoading: false,
        mainHeading:null,
        heading: null,
        tableData:null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DailyWorkChecklistProgressDashboardAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DailyWorkChecklistProgressDashboardAPI.fulfilled, (state, action) => {
            // const { mainHeading, heading, data } = action.payload;
            state.isLoading = false;
            state.tableData = action.payload;
            // state.mainHeading=mainHeading;
            // state.heading=heading;
        });
        builder.addCase(DailyWorkChecklistProgressDashboardAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})


export const DailyWorkChecklistProgressDashboardSliceReducer = DailyWorkChecklistProgressDashboardSlice.reducer
